"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

require("./Style.css");

var _idbReactIconlib = require("@identitybuilding/idb-react-iconlib");

var _idbReactIconlib2 = _interopRequireDefault(_idbReactIconlib);

var _ReviewItem = require("./components/ReviewItem");

var _ReviewItem2 = _interopRequireDefault(_ReviewItem);

var _AddReview = require("./AddReview");

var _AddReview2 = _interopRequireDefault(_AddReview);

var _reactSlick = require("react-slick");

var _reactSlick2 = _interopRequireDefault(_reactSlick);

require("slick-carousel/slick/slick.css");

require("slick-carousel/slick/slick-theme.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Reviews = function Reviews(props) {
  var slider = {
    dots: true,
    infinite: true,
    speed: 500,
    slidestoshow: 3,
    slidestoscroll: 3,
    arrows: false,
    variableWidth: true,
    rows: 1,
    autoplay: true,
    swipeToSlide: true
  };

  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      "section",
      {
        id: "review",
        className: [!props.template ? "temp-1" : "temp-" + props.template, !props.theme ? "light" : props.theme].join(" ")
      },
      _react2.default.createElement(
        "h2",
        null,
        props.title
      ),
      props.template === 1 && _react2.default.createElement(
        "div",
        { className: "card-container" },
        props.reviews.map(function (rev) {
          return _react2.default.createElement(_ReviewItem2.default, { key: rev.id, review: rev });
        })
      ),
      props.template === 2 && _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(
          "div",
          { className: "reviewslist" },
          _react2.default.createElement(
            "div",
            { id: "box" },
            _react2.default.createElement(
              _reactSlick2.default,
              slider,
              props.reviews.map(function (rev) {
                return _react2.default.createElement(_ReviewItem2.default, { key: rev.id, review: rev });
              })
            )
          )
        )
      ),
      props.template === 3 && _react2.default.createElement(
        "div",
        { className: "card-container" },
        _react2.default.createElement(
          _reactSlick2.default,
          slider,
          props.reviews.map(function (rev) {
            return _react2.default.createElement(_ReviewItem2.default, { key: rev.id, review: rev });
          })
        )
      ),
      props.template === 4 && _react2.default.createElement(
        "div",
        { className: "card-container" },
        props.reviews.map(function (rev) {
          return _react2.default.createElement(_ReviewItem2.default, { key: rev.id, review: rev });
        })
      ),
      props.template === 5 && _react2.default.createElement(
        "div",
        { className: "card-container" },
        _react2.default.createElement(
          _reactSlick2.default,
          slider,
          props.reviews.map(function (rev) {
            return _react2.default.createElement(_ReviewItem2.default, { key: rev.id, review: rev });
          })
        )
      )
    )
  );
};

exports.default = Reviews;